'use client';

import React from 'react';

import { Env, EnvContext } from '@flipster/utils/env';

const env: Env = {
  NODE_ENV: process.env.NODE_ENV as 'development' | 'production',
  NEXT_PUBLIC_COMMIT_HASH: process.env.NEXT_PUBLIC_COMMIT_HASH || '',
  NEXT_PUBLIC_VERSION: process.env.NEXT_PUBLIC_VERSION || '',
  NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL || '',
};

const EnvProvider = ({ children }: React.PropsWithChildren) => {
  return <EnvContext value={env}>{children}</EnvContext>;
};

export default EnvProvider;
